const referral = {
  tab: 'Referral Program',

  title: 'Invite Friends & Earn Rewards',
  subtitle: 'Share your personal link. For every friend who subscribes, you earn CHF 5 credit.',

  yourLink: {
    title: 'Your Referral Link',
    description: 'Friends who register through your link get 10% off their first month.',
    copy: 'Copy Link',
    copied: 'Copied!',
    generating: 'Referral code is being generated. Please refresh in a moment.',
    code: 'Your code:'
  },

  rewards: {
    title: 'Your Rewards',
    credit: 'CHF Credit',
    creditDescription: 'Applied to your next invoice',
    totalReferrals: 'Successful Referrals',
  },

  howItWorks: {
    title: 'How It Works',
    step1Title: 'Share Your Link',
    step1Text: 'Copy your personal link and share it with friends via message, email, or social media.',
    step2Title: 'Friend Subscribes',
    step2Text: 'Your friend registers and activates a paid plan. They get 10% off their first month.',
    step3Title: 'You Get Rewarded',
    step3Text: 'Once their payment is confirmed, you automatically receive CHF 5 credit on your account.',
  },

  history: {
    title: 'Referral History',
    empty: 'No successful referrals yet.',
    emptyHint: 'Share your link to get started!',
    friend: 'Friend',
    reward: 'Reward',
    date: 'Date',
    creditLabel: 'CHF {{value}} credit',
  },
};

export default referral;